export const DEFAULT_POINT_SIZE = 4;
